import React, { ReactNode } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import Loading from '../Loading';
import { twMerge } from 'tailwind-merge';

interface Props {
  initialLoad?: boolean;
  pageStart?: number;
  loader?: ReactNode;
  hasMore: boolean;
  loadMore?: (e?) => void;
  children: ReactNode;
  [key: string]: any;
  iconSize?: number;
  loaderClassName?: string;
}

export default function InfiniteScrollApp(props: Props) {
  return (
    <InfiniteScroll
      className={props?.className}
      initialLoad={props?.initialLoad || false}
      pageStart={props?.pageStart || 0}
      loader={
        props?.loader || (
          <div className={twMerge('py-2.5 flex items-center justify-center', props?.loaderClassName)} key={0}>
            <Loading width={props?.iconSize || 32} height={props?.iconSize || 32} />
          </div>
        )
      }
      threshold={320}
      hasMore={props.hasMore}
      loadMore={props.loadMore}
      {...props}>
      {props.children}
    </InfiniteScroll>
  );
}
